<script>
import moment from "moment";

const BLOOD_PRESSURE_SERVICE = '00001810-0000-1000-8000-00805f9b34fb';
const BLOOD_PRESSURE_MEASUREMENT_CHARACTERISTIC = '00002a35-0000-1000-8000-00805f9b34fb';
const OXYMETRY_SERVICE = '0000ff12-0000-1000-8000-00805f9b34fb';
const OXYMETRY_CHARACTERISTIC_DATA_IN = '0000ff01-0000-1000-8000-00805f9b34fb';
const OXYMETRY_CHARACTERISTIC_DATA_OUT = '0000ff02-0000-1000-8000-00805f9b34fb';
const TEMPERATURE_SERVICE = '00001809-0000-1000-8000-00805f9b34fb';
const TEMPERATURE_MEASUREMENT_CHARACTERISTIC = '00002a1c-0000-1000-8000-00805f9b34fb';
const HEALTH_SPIRO_CUSTOM_SERVICE = "0000fefb-0000-1000-8000-00805f9b34fb";
const HEALTH_SPIRO_CUSTOM_WRITE_WITHOUT_RESPONSE_CHARACTERISTIC = "00000001-0000-1000-8000-008025000000";
const HEALTH_SPIRO_CUSTOM_NOTIFY_CHARACTERISTIC = "00000002-0000-1000-8000-008025000000";
const HEALTH_SPIRO_CUSTOM_WRITE_CHARACTERISTIC = "00000003-0000-1000-8000-008025000000";
const HEALTH_SPIRO_CUSTOM_INDICATE_CHARACTERISTIC = "00000004-0000-1000-8000-008025000000";
const BODY_COMPOSITION_SERVICE_BF720 = '0000ffff-0000-1000-8000-00805f9b34fb';
const BODY_COMPOSITION_SET_TIME_SERVICE = '00001805-0000-1000-8000-00805f9b34fb';
const BODY_COMPOSITION_USER_DATA_SERVICE = '0000181c-0000-1000-8000-00805f9b34fb';
const BODY_COMPOSITION_WEIGHT_SERVICE = '0000181d-0000-1000-8000-00805f9b34fb';
const BODY_COMPOSITION_CUSTOM_SERVICE = '0000181b-0000-1000-8000-00805f9b34fb';
const BODY_COMPOSITION_SET_TIME_CHARACTERISTIC = '00002a2b-0000-1000-8000-00805f9b34fb';
const BODY_COMPOSITION_USER_LIST_CHARACTERISTIC_BF720 = '00000001-0000-1000-8000-00805f9b34fb';
const BODY_COMPOSITION_USER_DATA_CONTROL_POINT_CHARACTERISTIC = '00002a9f-0000-1000-8000-00805f9b34fb';
const BODY_COMPOSITION_GENDER_CHARACTERISTIC = '00002a8c-0000-1000-8000-00805f9b34fb';
const BODY_COMPOSITION_CHANGE_INCREMENT_CHARACTERISTIC = '00002a99-0000-1000-8000-00805f9b34fb';
const BODY_COMPOSITION_TAKE_MEASUREMENT_CHARACTERISTIC = '00000006-0000-1000-8000-00805f9b34fb';
const BODY_COMPOSITION_WEIGHT_MEASUREMENT_CHARACTERISTIC = '00002a9d-0000-1000-8000-00805f9b34fb';
const BODY_COMPOSITION_MEASUREMENT_CHARACTERISTIC = '00002a9c-0000-1000-8000-00805f9b34fb';

export default {
  data() {
    return {
      measuresFromBle: false,
      isBleAvailable: false,
      deviceName: "",
      waitingData: false,
      measurements: [],
      counter: 0,
      haveValues: false,
      numberMeasurements: 0,
      bufferSize: 24,
      array_of_arrays: [],
      scaleResponseLoginSend: false,
      pin: '4632',
      auxBuffer: [],
      readingFromBle: false,
    }
  },
  async created() {
    this.isBleAvailable = await navigator.bluetooth.getAvailability()
  },
  methods: {
    async handleBluetoothRead() {
      this.readingFromBle = true
      this.measuresFromBle = true
      this.measurement.measuresFromBle = true
      var dataArray = []
      let lastUpdateTime;

      const options = {
        acceptAllDevices: true,
        optionalServices: [
          BLOOD_PRESSURE_SERVICE,
          OXYMETRY_SERVICE,
          TEMPERATURE_SERVICE,
          HEALTH_SPIRO_CUSTOM_SERVICE,
          BODY_COMPOSITION_SERVICE_BF720,
          BODY_COMPOSITION_SET_TIME_SERVICE,
          BODY_COMPOSITION_USER_DATA_SERVICE,
          BODY_COMPOSITION_WEIGHT_SERVICE,
          BODY_COMPOSITION_CUSTOM_SERVICE
        ]
      }
      const inactivityTimeout = 1500;

      try {
        const device = await navigator.bluetooth.requestDevice(options);
        device.addEventListener('disconnect', () => {
          this.readingFromBle = false;
        });
        device.addEventListener('ongattserverdisconnected', () => {
          this.readingFromBle = false;
        })

        // Blood Pressure
        if (device.name != null && (device.name === "BM54" || device.name === "Beurer BM85" || device.name === "BM81")) {
          // Connect to the device
          try {
            const server = await device.gatt.connect();
            const service = await server.getPrimaryService(BLOOD_PRESSURE_SERVICE);
            const characteristic = await service.getCharacteristic(BLOOD_PRESSURE_MEASUREMENT_CHARACTERISTIC);
            await characteristic.startNotifications();

            characteristic.addEventListener('characteristicvaluechanged', (event) => {
              const data = new Uint8Array(event.target.value.buffer);
              if (data != null) {
                var systolicValue
                var diastoliValue
                var pulseValue

                if (device.name === "BM54" || device.name === "BM81") {
                  systolicValue = data[1];
                  diastoliValue = data[3];
                  pulseValue = data[14];
                } else {
                  systolicValue = data[1];
                  diastoliValue = data[3];
                  pulseValue = data[15];
                }

                dataArray.push(
                  {systolic: systolicValue, diastolic: diastoliValue, pulse: pulseValue}
                )

                lastUpdateTime = Date.now();
                setTimeout(() => {
                  const currentTime = Date.now();
                  const elapsedTime = currentTime - lastUpdateTime;
                  if (elapsedTime >= inactivityTimeout) {
                    this.readingFromBle = false
                    let obj = null
                    if(device.name === "BM81") {
                      obj = dataArray[0]
                    } else {
                      obj = dataArray[dataArray.length-1]
                    }
                    this.form.sistolic = obj.systolic
                    this.form.diastolic = obj.diastolic
                    this.form.heartRate = obj.pulse
                    let deviceId = null
                    if(device.name === "BM81") {
                      deviceId = 55
                    } else if (device.name === "Beurer BM85") {
                      deviceId = 50
                    } else if (device.name === "BM54") {
                      deviceId = 51
                    }
                    this.form.equipmentType = {
                      idEquipmentType: deviceId
                    }
                  }
                }, inactivityTimeout);

                console.log("Systolic value = " + systolicValue);
                console.log("Dyastolic value = " + diastoliValue);
                console.log("Pulse value = " + pulseValue);
              }
            });
          } catch (e) {
            console.log(e)
            this.measuresFromBle = false
            this.readingFromBle = false
          }


        }

        //Termometer
        if (device.name != null && device.name === "FT95") {
          try {
            const server = await device.gatt.connect();
            const service = await server.getPrimaryService(TEMPERATURE_SERVICE);
            const characteristic = await service.getCharacteristic(TEMPERATURE_MEASUREMENT_CHARACTERISTIC);
            await characteristic.startNotifications();
            characteristic.addEventListener('characteristicvaluechanged', (event) => {
              const data = new Uint8Array(event.target.value.buffer);
              if (data != null) {
                var temperature = (data[2] << 8) + data[1];
                var temperature_int = temperature / 10;
                dataArray.push(temperature_int)

                lastUpdateTime = Date.now();
                setTimeout(() => {
                  const currentTime = Date.now();
                  const elapsedTime = currentTime - lastUpdateTime;
                  if (elapsedTime >= inactivityTimeout) {
                    console.log('Bluetooth values have stopped.');
                    console.log("Last values: ")
                    console.log(dataArray[dataArray.length-1])
                    this.readingFromBle = false
                    this.form.temperature = dataArray[dataArray.length-1]
                    this.form.equipmentType = {
                      idEquipmentType: 60
                    }
                  }
                }, inactivityTimeout);
                //console.log("Temperature value = " + temperature_int);
                /*switch (data[0]) {
                  case 0x86:
                    //console.log("Has fever");
                    break;
                  default:
                    //console.log("Normal value, no fever");
                    break;
                }*/
              }
            });
          } catch(e) {
            this.readingFromBle = false
            this.measuresFromBle = false
          }
        }

        // Spirometer
        if (device.name != null && device.name.includes("LUNG")) {
          try {
            // Connect to the device
            const server = await device.gatt.connect();
            const service = await server.getPrimaryService(HEALTH_SPIRO_CUSTOM_SERVICE);
            // Get characteristics
            const characteristicWriteWithoutResponse = await service.getCharacteristic(HEALTH_SPIRO_CUSTOM_WRITE_WITHOUT_RESPONSE_CHARACTERISTIC);
            const characteristicNotify = await service.getCharacteristic(HEALTH_SPIRO_CUSTOM_NOTIFY_CHARACTERISTIC);
            const characteristicWrite = await service.getCharacteristic(HEALTH_SPIRO_CUSTOM_WRITE_CHARACTERISTIC);
            const characteristicIndicate = await service.getCharacteristic(HEALTH_SPIRO_CUSTOM_INDICATE_CHARACTERISTIC);

            // Start notifications for the characteristic
            await characteristicNotify.startNotifications();
            await characteristicIndicate.startNotifications();

            // Notify spirometer to send data
            await characteristicWrite.writeValueWithResponse(this.getNotifySpiroData());
            await characteristicWriteWithoutResponse.writeValueWithoutResponse(this.getNotifySpiroData());
            var auxBuffer = []

            // Listen for indications
            characteristicIndicate.addEventListener('characteristicvaluechanged', (event) => {
              const data = new Uint8Array(event.target.value.buffer);
              console.log("Listen to indications");
              // Process the data
              if (data != null) {
                if (data[0] === 23) {
                } else if (data[0] === 2) {
                  // auxBuffer = Array.prototype.push.apply(auxBuffer, data);
                  auxBuffer.push(data);
                  if (auxBuffer.length === 6) {
                    console.log("Device off! Disconnecting...");
                    device.gatt.disconnect();
                  } else {
                    console.log("Sending write command to get rest of the data");
                    characteristicWrite.writeValueWithResponse(this.getNotifySpiroData());
                  }
                } else {
                  // Array.prototype.push.apply(auxBuffer, data);
                  auxBuffer.push(data);
                  if (data.length < 20) {
                    var spiroData = [];
                    auxBuffer.forEach(elem => {
                      if(typeof(elem) === "number") {
                        spiroData.push(elem)
                      } else {
                        spiroData.push(...elem)
                      }
                    })
                    /*for (let i=0; i<auxBuffer.length; i++) {
                      for (let j=0; j<auxBuffer[i].length; j++) {
                        var array = auxBuffer[i];
                        spiroData.push(array[j])
                      }
                    }*/
                    var fev1 = String.fromCharCode(spiroData[20]) + "." + String.fromCharCode(spiroData[21]) + String.fromCharCode(spiroData[22]);
                    var fev6 = String.fromCharCode(spiroData[23]) + "." + String.fromCharCode(spiroData[24]) + String.fromCharCode(spiroData[25]);
                    var fev1fev6 = String.fromCharCode(spiroData[26]) + "." + String.fromCharCode(spiroData[27]) + String.fromCharCode(spiroData[28]);
                    var fef2575 = String.fromCharCode(spiroData[29]) + "." + String.fromCharCode(spiroData[30]) + String.fromCharCode(spiroData[31]);
                    var validTest = String.fromCharCode(spiroData[65]);
                    console.log("fev1 = " + fev1);
                    console.log("fev6 = " + fev6);
                    console.log("fev1fev6 = " + fev1fev6);
                    console.log("fef2575 = " + fef2575);
                    console.log("validTest = " + (validTest == "0" ? "Medição realizada com sucesso." : "Medição inválida. Repetir o teste."));

                    this.form.forcedExpiratoryVol6Sec = fev6
                    this.form.forcedExpiratoryVol1Sec = fev1
                    this.form.fev1fev6 = fev1fev6
                    this.form.forcedMidExpiratoryFlow = fef2575
                    this.form.equipmentType = {
                      idEquipmentType: 75
                    }
                    this.readingFromBle = false

                    device.gatt.disconnect();
                  } else {
                    console.log("Sending write command to get rest of the data");
                    characteristicWrite.writeValueWithResponse(this.getNotifySpiroData());
                  }
                }
              }
            });

            // Listen for notifications
            characteristicNotify.addEventListener('characteristicvaluechanged', (event) => {
              const data = new Uint8Array(event.target.value.buffer);
              console.log("Listen to notifications");
              // Process the data
              if (data != null) {

                if (data[0] === 23) {
                  console.log("write response received");
                } else if (data[0] === 2) {
                  // auxBuffer = Array.prototype.push.apply(auxBuffer, data);
                  auxBuffer.push(...data);
                  if (auxBuffer.length === 6) {
                    console.log("Device off! Disconnecting...");
                    device.gatt.disconnect();
                    this.readingFromBle = false
                  } else {
                    console.log("Sending write command to get rest of the data");
                    characteristicWrite.writeValueWithResponse(this.getNotifySpiroData());
                  }
                } else {
                  // Array.prototype.push.apply(auxBuffer, data);
                  auxBuffer.push(data);
                  console.log(auxBuffer)
                  if (data.length < 20) {
                    var spiroData = [];
                    auxBuffer.forEach(elem => {
                      if(typeof(elem) === "number") {
                        spiroData.push(elem)
                      } else {
                        spiroData.push(...elem)
                      }
                    })

                    console.log("spiroData = " + spiroData);
                    var fev1 = String.fromCharCode(spiroData[20]) + "." + String.fromCharCode(spiroData[21]) + String.fromCharCode(spiroData[22]);
                    var fev6 = String.fromCharCode(spiroData[23]) + "." + String.fromCharCode(spiroData[24]) + String.fromCharCode(spiroData[25]);
                    var fev1fev6 = String.fromCharCode(spiroData[26]) + "." + String.fromCharCode(spiroData[27]) + String.fromCharCode(spiroData[28]);
                    var fef2575 = String.fromCharCode(spiroData[29]) + "." + String.fromCharCode(spiroData[30]) + String.fromCharCode(spiroData[31]);
                    var validTest = String.fromCharCode(spiroData[65]);
                    console.log("fev1 = " + fev1);
                    console.log("fev6 = " + fev6);
                    console.log("fev1fev6 = " + fev1fev6);
                    console.log("fef2575 = " + fef2575);
                    console.log("validTest = " + (validTest === "0" ? "Medição realizada com sucesso." : "Medição inválida. Repetir o teste."));
                    this.form.forcedExpiratoryVol6Sec = fev6
                    this.form.forcedExpiratoryVol1Sec = fev1
                    this.form.fev1fev6 = fev1fev6
                    this.form.forcedMidExpiratoryFlow = fef2575
                    this.form.equipmentType = {
                      idEquipmentType: 75
                    }
                    this.readingFromBle = false

                  } else {
                    console.log("Sending write command to get rest of the data");
                    characteristicWrite.writeValueWithResponse(this.getNotifySpiroData());
                  }
                }
              }
            });
          } catch (e) {
            console.log(e)
            this.measuresFromBle = false
            this.readingFromBle = false
          }
        }

        //Oxymeter
        if (device.name != null && device.name === 'PO60') {
          try {
            // Connect to the device
            const server = await device.gatt.connect();
            console.log("Connect to oximeter " + device.name);

            // Get primary service
            const service = await server.getPrimaryService(OXYMETRY_SERVICE);
            // Get characteristics for data in and out
            const characteristicDataIn = await service.getCharacteristic(OXYMETRY_CHARACTERISTIC_DATA_IN);
            const characteristicDataOut = await service.getCharacteristic(OXYMETRY_CHARACTERISTIC_DATA_OUT);

            // Update date on oxymeter
            await characteristicDataIn.writeValueWithResponse(this.setOxymeterTime());
            await characteristicDataOut.startNotifications();
            // Listen for characteristic value changes
            characteristicDataOut.addEventListener('characteristicvaluechanged', (event) => {
              const data = new Uint8Array(event.target.value.buffer);
              // Process the data
              if (data != null) {
                if (this.waitingData) {
                  this.measurements.push(data);
                  if (this.checkIsHeaderPresent(data)) {
                    this.counter = this.counter + 1;
                  }
                  const flatten = this.measurements.reduce((accumulator, value) => accumulator.concat(value), []);

                  var numElements = 0;
                  for (let i=0; i<flatten.length; i++) {
                    numElements += flatten[i].length
                  }

                  if ((this.counter === this.numberMeasurements) && (numElements === (this.counter * 24))) {
                    this.waitingData = false;
                    var oxyData = [];
                    for (let i=0; i<flatten.length; i++) {
                      for (let j=0; j<flatten[i].length; j++) {
                        var array = flatten[i];
                        oxyData.push(array[j])
                      }
                    }
                    console.log("Oxy data = ", oxyData);

                    var start_year = oxyData[2];
                    var start_month = oxyData[3];
                    var start_day = oxyData[4];
                    var start_hour = oxyData[5];
                    var start_minute = oxyData[6];
                    var start_seconds = oxyData[7];

                    var startDate = new Date();
                    startDate.setFullYear(2000 + start_year);
                    startDate.setMonth(start_month - 1);
                    startDate.setUTCDate(start_day);
                    startDate.setHours(start_hour);
                    startDate.setMinutes(start_minute);
                    startDate.setSeconds(start_seconds);
                    console.log("Start date = ", startDate);

                    var end_year = oxyData[8];
                    var end_month = oxyData[9];
                    var end_day = oxyData[10];
                    var end_hour = oxyData[11];
                    var end_minute = oxyData[12];
                    var end_seconds = oxyData[13];

                    var endDate = new Date();
                    endDate.setFullYear(2000 + end_year);
                    endDate.setMonth(end_month - 1);
                    endDate.setUTCDate(end_day);
                    endDate.setHours(end_hour);
                    endDate.setMinutes(end_minute);
                    endDate.setSeconds(end_seconds);
                    console.log("End date = ", endDate);

                    var spo_max = oxyData[17];
                    var spo_min = oxyData[18];
                    var spo_avg = oxyData[19];

                    console.log("SPO MAX: " + spo_max);
                    console.log("SPO MIN: " + spo_min);
                    console.log("SPO AVG: " + spo_avg);

                    var pr_max = oxyData[20];
                    var pr_min = oxyData[21];
                    var pr_avg = oxyData[22];

                    console.log("PR MAX: " + pr_max);
                    console.log("PR MIN: " + pr_min);
                    console.log("PR AVG: " + pr_avg);

                    var duration = moment.duration(moment(endDate).diff(moment(startDate)));
                    var minutesDuration = duration.asMinutes();

                    this.form.durationSession = minutesDuration
                    this.form.oximetryMax = spo_max
                    this.form.oximetryMin = spo_min
                    this.form.oximetryAvg = spo_avg
                    this.form.pulseRateMax = pr_max
                    this.form.pulseRateMin = pr_min
                    this.form.pulseRateAvg = pr_avg
                    this.form.equipmentType = {
                      idEquipmentType: 70
                    }
                    this.readingFromBle = false

                    // Delete measurements
                    console.log("Deleting oxy data...")
                    characteristicDataIn.writeValueWithResponse(this.deleteOxyData());

                  }
                  else if ((this.counter % 10 == 0) && (this.counter * 24 == flatten.length)) {
                    characteristicDataIn.writeValueWithResponse(this.getOxyNextData());
                  }
                }

                switch (data[0]) {
                  case 0xF3:
                    console.log("Sucess time sync!");
                    characteristicDataIn.writeValueWithResponse(this.getOxyNumberData());
                    break;
                  case 0xE0:
                    console.log("Request data");
                    const val = data[5] * 256 + data[4];
                    this.numberMeasurements = val;
                    this.waitingData = true;
                    if (this.numberMeasurements === 0) {
                      this.measuresFromBle = false
                      this.readingFromBle = false
                    }
                    characteristicDataIn.writeValueWithResponse(this.getOxyData());
                    break;
                }
              }

            });
          } catch (e) {
            console.log(e)
            this.measuresFromBle = false
            this.readingFromBle = false
          }
        }
      } catch (e) {
        this.readingFromBle = false
        this.measuresFromBle = false
        this.measurement.measuresFromBle = false
      }

    },

    setOxymeterTime() {
      var today = new Date();
      var array = new Uint8Array(10);
      array[0] = 0x83
      array[1] = parseInt((today.getFullYear() - 2000).toString(), 10);
      array[2] = parseInt((today.getMonth() + 1).toString(), 10);
      array[3] = parseInt(today.getUTCDate().toString(), 10);
      array[4] = parseInt(today.getHours().toString(), 10);
      array[5] = parseInt(today.getMinutes().toString(), 10);
      array[6] = parseInt(today.getSeconds().toString(), 10);
      array[7] = 0x00;
      array[8] = 0x00;
      array[9] = 0x00;
      array = this.bytesToChecksum(array);
      return array;
    },

    bytesToChecksum(array) {
      var sum = 0x00;
      for (var element in array) {
        sum = sum + array[element];
      }
      array[array.length - 1] = sum & 0x7F;
      return array
    },
    checkIsHeaderPresent(data) {
      var isPresent = false;
      for (var element in data) {
        if (data[element] == 0xE9) {
          isPresent = true;
          break;
        }
      }
      return isPresent;
    },
    deleteOxyData() {
      var array = new Uint8Array(3);
      array[0] = 0x99;
      array[1] = 0x7F;
      array[2] = 0x00;
      array = this.bytesToChecksum(array);
      return array;
    },

    getOxyNextData() {
      var array = new Uint8Array(3);
      array[0] = 0x99;
      array[1] = 0x01;
      array[2] = 0x00;
      array = this.bytesToChecksum(array);
      return array;
    },

    getOxyNumberData() {
      var array = new Uint8Array(3);
      array[0] = 0x90;
      array[1] = 0x05;
      array[2] = 0x00;
      array = this.bytesToChecksum(array);
      return array;
    },

    getOxyData() {
      var array = new Uint8Array(3);
      array[0] = 0x99;
      array[1] = 0;
      array[2] = 0x00;
      array = this.bytesToChecksum(array);
      return array;
    },

    getNotifySpiroData() {
      var array = new Uint8Array(1);
      array[0] = 0x01;
      return array;
    }
  }
}
</script>

<style scoped>

</style>
